<template>
  <section>
    <China></China>
    <c-homeDialog></c-homeDialog>
  </section>
</template>
<script>
import China from './homes/china.vue';

export default {
  components: {
    China,
  },
};
</script>
